import EmailAndMessagingDocsFeature from '../../features/docs/email-and-messaging-feature';

export default function EmailAndMessagingDocsPage() {
  return <EmailAndMessagingDocsFeature />;
}
